var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCard2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 99,
    viewBox: "0 0 102 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-2user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.3245 56.1617C46.8079 56.11 46.1879 56.11 45.6195 56.1617C33.3229 55.7483 23.5579 45.6733 23.5579 33.2733C23.5579 20.615 33.7879 10.3333 46.4979 10.3333C59.1562 10.3333 69.4379 20.615 69.4379 33.2733C69.3862 45.6733 59.6212 55.7483 47.3245 56.1617Z",
    stroke: "#EFEFEF",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M84.7864 20.6667C94.8097 20.6667 102.87 28.7783 102.87 38.75C102.87 48.515 95.1197 56.4717 85.4581 56.8333C85.0447 56.7817 84.5797 56.7817 84.1147 56.8333",
    stroke: "#EFEFEF",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.492 75.2267C8.98867 83.5967 8.98867 97.2367 21.492 105.555C35.7003 115.062 59.002 115.062 73.2103 105.555C85.7137 97.185 85.7137 83.545 73.2103 75.2267C59.0537 65.7717 35.752 65.7717 21.492 75.2267Z",
    stroke: "#EFEFEF",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M94.7566 103.333C98.4766 102.558 101.99 101.06 104.883 98.8383C112.943 92.7933 112.943 82.8217 104.883 76.7767C102.042 74.6067 98.5799 73.16 94.9116 72.3333",
    stroke: "#EFEFEF",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCard2Icon);
export default __webpack_public_path__ + "static/media/home_card2_icon.ebcf0ee433524af88e366d62cfd299e6.svg";
export { ForwardRef as ReactComponent };